"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefDecimalIfNotSet = exports.DEFAULT_NETWORK_DECIMALS = exports.NETWORK_DETAIL = exports.getNetworkPair = exports.CreditPaymentReason = exports.Entity = exports.TransactionValidationType = exports.TransactionPayloadType = exports.Network = exports.TransactionType = exports.IgnoreWalletReason = exports.TRANSACTION_DEFAULT_AUCTION = exports.TRANSACTION_MAX_EXPIRY_MS = exports.TRANSACTION_AUTO_EXPIRY_MS = void 0;
exports.TRANSACTION_AUTO_EXPIRY_MS = 4 * 60 * 1000;
exports.TRANSACTION_MAX_EXPIRY_MS = 31 * 24 * 60 * 60 * 1000;
exports.TRANSACTION_DEFAULT_AUCTION = 3 * 24 * 60 * 60 * 1000;
var IgnoreWalletReason;
(function (IgnoreWalletReason) {
    IgnoreWalletReason["NONE"] = "";
    IgnoreWalletReason["UNREFUNDABLE_DUE_UNLOCK_CONDITIONS"] = "UnrefundableDueUnlockConditions";
    IgnoreWalletReason["UNREFUNDABLE_DUE_TIMELOCK_CONDITION"] = "UNREFUNDABLE_DUE_TIMELOCK_CONDITION";
    IgnoreWalletReason["UNREFUNDABLE_DUE_STORAGE_DEPOSIT_CONDITION"] = "UNREFUNDABLE_DUE_STORAGE_DEPOSIT_CONDITION";
    IgnoreWalletReason["PRE_MINTED_AIRDROP_CLAIM"] = "pre_minted_airdrop_claim";
    IgnoreWalletReason["EXTRA_STAKE_REWARD"] = "EXTRA_STAKE_REWARD";
    IgnoreWalletReason["MISSING_TARGET_ADDRESS"] = "MISSING_TARGET_ADDRESS";
})(IgnoreWalletReason || (exports.IgnoreWalletReason = IgnoreWalletReason = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["VOTE"] = "VOTE";
    TransactionType["ORDER"] = "ORDER";
    TransactionType["PAYMENT"] = "PAYMENT";
    TransactionType["BILL_PAYMENT"] = "BILL_PAYMENT";
    TransactionType["CREDIT"] = "CREDIT";
    TransactionType["CREDIT_TANGLE_REQUEST"] = "CREDIT_TANGLE_REQUEST";
    TransactionType["CREDIT_STORAGE_DEPOSIT_LOCKED"] = "CREDIT_STORAGE_DEPOSIT_LOCKED";
    TransactionType["MINT_COLLECTION"] = "MINT_COLLECTION";
    TransactionType["CREDIT_NFT"] = "CREDIT_NFT";
    TransactionType["WITHDRAW_NFT"] = "WITHDRAW_NFT";
    TransactionType["MINT_TOKEN"] = "MINT_TOKEN";
    TransactionType["AWARD"] = "AWARD";
    TransactionType["UNLOCK"] = "UNLOCK";
    TransactionType["METADATA_NFT"] = "METADATA_NFT";
    TransactionType["STAMP"] = "STAMP";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
/**
 * Available DLT networks within BUILD.5
 */
var Network;
(function (Network) {
    Network["IOTA"] = "iota";
    /** Only available on wen environment. */
    Network["ATOI"] = "atoi";
    Network["SMR"] = "smr";
    /** Only available on wen environment. */
    Network["RMS"] = "rms";
})(Network || (exports.Network = Network = {}));
var TransactionPayloadType;
(function (TransactionPayloadType) {
    TransactionPayloadType["NFT_PURCHASE"] = "NFT_PURCHASE";
    TransactionPayloadType["NFT_BID"] = "NFT_BID";
    TransactionPayloadType["AUCTION_BID"] = "AUCTION_BID";
    TransactionPayloadType["SPACE_ADDRESS_VALIDATION"] = "SPACE_ADDRESS_VALIDATION";
    TransactionPayloadType["MEMBER_ADDRESS_VALIDATION"] = "MEMBER_ADDRESS_VALIDATION";
    TransactionPayloadType["TOKEN_PURCHASE"] = "TOKEN_PURCHASE";
    TransactionPayloadType["TOKEN_AIRDROP"] = "TOKEN_AIRDROP";
    TransactionPayloadType["MINT_TOKEN"] = "MINT_TOKEN";
    TransactionPayloadType["CLAIM_MINTED_TOKEN"] = "CLAIM_MINTED_TOKEN";
    TransactionPayloadType["CLAIM_BASE_TOKEN"] = "CLAIM_BASE_TOKEN";
    TransactionPayloadType["SELL_TOKEN"] = "SELL_TOKEN";
    TransactionPayloadType["BUY_TOKEN"] = "BUY_TOKEN";
    TransactionPayloadType["MINT_COLLECTION"] = "MINT_COLLECTION";
    TransactionPayloadType["DEPOSIT_NFT"] = "DEPOSIT_NFT";
    TransactionPayloadType["AIRDROP_MINTED_TOKEN"] = "AIRDROP_MINTED_TOKEN";
    TransactionPayloadType["CREDIT_LOCKED_FUNDS"] = "CREDIT_LOCKED_FUNDS";
    TransactionPayloadType["STAKE"] = "STAKE";
    TransactionPayloadType["TANGLE_REQUEST"] = "TANGLE_REQUEST";
    TransactionPayloadType["PROPOSAL_VOTE"] = "PROPOSAL_VOTE";
    TransactionPayloadType["CLAIM_SPACE"] = "CLAIM_SPACE";
    TransactionPayloadType["STAKE_NFT"] = "STAKE_NFT";
    TransactionPayloadType["FUND_AWARD"] = "FUND_AWARD";
    TransactionPayloadType["IMPORT_TOKEN"] = "IMPORT_TOKEN";
    TransactionPayloadType["MINT_METADATA_NFT"] = "MINT_METADATA_NFT";
    TransactionPayloadType["MINT_ALIAS"] = "MINT_ALIAS";
    TransactionPayloadType["BADGE"] = "BADGE";
    TransactionPayloadType["BURN_ALIAS"] = "BURN_ALIAS";
    TransactionPayloadType["NONE"] = "";
    TransactionPayloadType["TOKEN_BUY"] = "TOKEN_BUY";
    TransactionPayloadType["AWARD_COMPLETED"] = "AWARD_COMPLETED";
    TransactionPayloadType["TOKEN_VAULT_EMPTIED"] = "TOKEN_VAULT_EMPTIED";
    TransactionPayloadType["TOKEN_TRADE_FULLFILLMENT"] = "TOKEN_TRADE_FULLFILLMENT";
    TransactionPayloadType["ADDRESS_VALIDATION"] = "ADDRESS_VALIDATION";
    TransactionPayloadType["TRANSACTION_ALREADY_UNLOCKED"] = "TRANSACTION_ALREADY_UNLOCKED";
    TransactionPayloadType["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    TransactionPayloadType["INVALID_PAYMENT"] = "INVALID_PAYMENT";
    TransactionPayloadType["TOKEN_VOTE"] = "TOKEN_VOTE";
    TransactionPayloadType["DATA_NO_LONGER_VALID"] = "DATA_NO_LONGER_VALID";
    TransactionPayloadType["SPACE_CALIMED"] = "SPACE_CALIMED";
    TransactionPayloadType["PRE_MINTED_CLAIM"] = "PRE_MINTED_CLAIM";
    TransactionPayloadType["UNLOCK_FUNDS"] = "UNLOCK_FUNDS";
    TransactionPayloadType["UNLOCK_NFT"] = "UNLOCK_NFT";
    TransactionPayloadType["TANGLE_TRANSFER"] = "TANGLE_TRANSFER";
    TransactionPayloadType["MINT_NFT"] = "MINT_NFT";
    TransactionPayloadType["UPDATE_MINTED_NFT"] = "UPDATE_MINTED_NFT";
    TransactionPayloadType["MINT_NFTS"] = "MINT_NFTS";
    TransactionPayloadType["LOCK_COLLECTION"] = "LOCK_COLLECTION";
    TransactionPayloadType["SEND_ALIAS_TO_GUARDIAN"] = "SEND_ALIAS_TO_GUARDIAN";
    TransactionPayloadType["MINT_FOUNDRY"] = "MINT_FOUNDRY";
    TransactionPayloadType["MINTED_AIRDROP_CLAIM"] = "MINTED_AIRDROP_CLAIM";
    TransactionPayloadType["PRE_MINTED_AIRDROP_CLAIM"] = "PRE_MINTED_AIRDROP_CLAIM";
    TransactionPayloadType["PRE_MINTED_TOKEN_TRADE"] = "PRE_MINTED_TOKEN_TRADE";
    TransactionPayloadType["MINTED_TOKEN_TRADE"] = "MINTED_TOKEN_TRADE";
    TransactionPayloadType["BASE_TOKEN_TRADE"] = "BASE_TOKEN_TRADE";
    TransactionPayloadType["BASE_AIRDROP_CLAIM"] = "BASE_AIRDROP_CLAIM";
    TransactionPayloadType["STAMP"] = "STAMP";
})(TransactionPayloadType || (exports.TransactionPayloadType = TransactionPayloadType = {}));
var TransactionValidationType;
(function (TransactionValidationType) {
    TransactionValidationType[TransactionValidationType["ADDRESS_AND_AMOUNT"] = 0] = "ADDRESS_AND_AMOUNT";
    TransactionValidationType[TransactionValidationType["ADDRESS"] = 1] = "ADDRESS";
})(TransactionValidationType || (exports.TransactionValidationType = TransactionValidationType = {}));
var Entity;
(function (Entity) {
    Entity["SPACE"] = "space";
    Entity["MEMBER"] = "member";
})(Entity || (exports.Entity = Entity = {}));
var CreditPaymentReason;
(function (CreditPaymentReason) {
    CreditPaymentReason["TRADE_CANCELLED"] = "trade_cancelled";
})(CreditPaymentReason || (exports.CreditPaymentReason = CreditPaymentReason = {}));
const getNetworkPair = (network) => {
    switch (network) {
        case Network.IOTA:
            return Network.SMR;
        case Network.ATOI:
            return Network.RMS;
        case Network.SMR:
            return Network.IOTA;
        case Network.RMS:
            return Network.ATOI;
    }
};
exports.getNetworkPair = getNetworkPair;
exports.NETWORK_DETAIL = {
    [Network.IOTA]: {
        label: 'IOTA',
        divideBy: 1000 * 1000,
        decimals: 6,
    },
    [Network.ATOI]: {
        label: 'ATOI',
        divideBy: 1000 * 1000,
        decimals: 6,
    },
    [Network.SMR]: {
        label: Network.SMR.toUpperCase(),
        divideBy: 1000 * 1000,
        decimals: 6,
    },
    [Network.RMS]: {
        label: Network.RMS.toUpperCase(),
        divideBy: 1000 * 1000,
        decimals: 6,
    },
};
exports.DEFAULT_NETWORK_DECIMALS = 6;
const getDefDecimalIfNotSet = (v) => {
    return v !== undefined && v !== null && v > -1 ? v : exports.DEFAULT_NETWORK_DECIMALS;
};
exports.getDefDecimalIfNotSet = getDefDecimalIfNotSet;
